import { useAuth } from "@/hooks/use-auth";
import { Loader2 } from "lucide-react";
import { Redirect, Route, useLocation } from "wouter";
import React, { useState, useEffect } from "react";

type ComponentProps = React.ComponentType<any>;

export function ProtectedRoute({
  path,
  component: Component,
}: {
  path: string;
  component: ComponentProps;
}) {
  const { user, isLoading } = useAuth();
  const [sessionChecked, setSessionChecked] = useState(false);
  const [hasSession, setHasSession] = useState(false);

  // Check localStorage on mount
  useEffect(() => {
    const hasActiveSession =
      localStorage.getItem("auth_session_active") === "true";
    console.log("Protected route - active session flag:", hasActiveSession);
    setHasSession(hasActiveSession);
    setSessionChecked(true);
  }, []);

  // While checking auth status, show loading
  if (!sessionChecked || isLoading) {
    return (
      <Route path={path}>
        <div className="flex items-center justify-center min-h-screen">
          <Loader2 className="h-8 w-8 animate-spin text-border" />
        </div>
      </Route>
    );
  }

  // No authenticated user
  if (!user) {
    // If we have an active session flag but no user, wait a bit
    if (hasSession) {
      localStorage.removeItem("auth_session_active");
      // Give the auth state a chance to be retrieved from the server
      return (
        <Route path={path}>
          <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
              <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4 text-primary" />
              <p className="text-sm text-gray-500">
                Retrieving your session...
              </p>
            </div>
          </div>
        </Route>
      );
    }

    // No session, clear flag and redirect to auth
    console.log("No authenticated user found, redirecting to auth page...");
    localStorage.removeItem("auth_session_active");

    return (
      <Route path={path}>
        <Redirect to="/landing-page" />
      </Route>
    );
  }

  // User is authenticated, render component
  return (
    <Route path={path}>
      <Component />
    </Route>
  );
}
